import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { MatIconModule } from "@angular/material";
import { ReactiveFormsModule } from "@angular/forms";

import { ButtonComponent } from "./button/button.component";
import { IconComponent } from "./icon/icon.component";
import { MessageComponent } from "./message/message.component";
import { InputComponent } from "./input/input.component";
import { RadioGroupComponent } from "./radio-group/radio-group.component";
import { TwoColumnLayoutComponent } from "./two-column-layout/two-column-layout.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { MarketingSidebarComponent } from "./sidebar/marketing-sidebar/marketing-sidebar.component";
import { CheckboxComponent } from "./checkbox/checkbox.component";
import { VerificationFormComponent } from "./steps/verification-form/verification-form.component";
import { SuccessMessageComponent } from "./steps/success-message/success-message.component";
import { LearnMoreInfoBoxComponent } from "./learn-more-info-box/learn-more-info-box.component";
@NgModule({
	declarations: [
		ButtonComponent, 
		IconComponent, 
		MessageComponent, 
		InputComponent, 
		RadioGroupComponent, 
		TwoColumnLayoutComponent,
		SidebarComponent,
		MarketingSidebarComponent,
		CheckboxComponent,
		VerificationFormComponent,
		SuccessMessageComponent,
		LearnMoreInfoBoxComponent
	],
	imports: [
		CommonModule,
		RouterModule,
		MatIconModule,
		ReactiveFormsModule,
	],
	exports: [
		ButtonComponent, 
		IconComponent, 
		MessageComponent, 
		InputComponent, 
		RadioGroupComponent,
		TwoColumnLayoutComponent,
		CheckboxComponent,
		VerificationFormComponent,
		SuccessMessageComponent,
		LearnMoreInfoBoxComponent,
		SidebarComponent,
		MarketingSidebarComponent
	]
})
export class SharedModule { }
